import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, NgZone, Input, SimpleChanges } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSidenav } from '@angular/material';
import { Observable } from 'rxjs';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { UtilityService } from 'src/app/services/utility.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetService } from '../../services/asset.service';
import { MapsService } from 'src/app/services/maps.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-saftey-critical-form',
  templateUrl: './saftey-critical-form.component.html',
  styleUrls: ['./saftey-critical-form.component.scss']
})
export class SafteyCriticalFormComponent implements OnInit {



  loading
  isEdit: Boolean
  isMapEdit: Boolean
  files: any = [];
  newFiles: any = [];
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  map: google.maps.Map;
  bounds
  geoCoder
  assetId
  safetyCriticalFormData = []
  selectedIndex
  selectedFormDetails
  currentUser: any;
  safetyCriticalForm: FormGroup
  userId
  previousIndex
  _isControlDisable = false
  _isEnableMap = true


  @Input('asset') assetData
  @Input('user') userData
  @Input('documentData') documentDetails
  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  // @ViewChild('search', { static: false })
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  constructor(
    public dialog: MatDialog,
    public router: Router,
    public _utilityService: UtilityService,
    public _userDocumentService: UserDocumentService,
    public activatedRouter: ActivatedRoute,
    public _assetService: AssetService,
  ) {
  }






  ngOnInit() {

    this.activatedRouter.params.subscribe(params => {
      this.assetId = params.id;
      console.log('check params data..', params, this.assetId)
    })

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    this.createForm();
    // this.isMapEdit=false
    // this.setCurrentLocation()

  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("Inspection form changes", changes);
    if (changes.assetData && changes.assetData.currentValue) {
      this.assetData = changes.assetData.currentValue
      console.log("this.assetData", this.assetData);
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
      console.log("this.userData", this.userData);
    }

    if (changes.documentDetails && changes.documentDetails.currentValue && changes.documentDetails.currentValue.length) {

      let data = changes.documentDetails.currentValue
      console.log("data--->", data);
      let allFormList = data.filter((x) => {
        if (x.userDocumentId && x.userDocumentId.documentMetaId && x.userDocumentId.documentMetaId.title) {
          return x.userDocumentId.documentMetaId.title === 'safety_critical_form'
        }
      }
      )


      if (allFormList && allFormList.length) {
        this.safetyCriticalFormData = allFormList
        this.selectedIndex = this.safetyCriticalFormData[0]._id
        this.selectedFormDetails = this.safetyCriticalFormData[0].userDocumentId
        this._isControlDisable = true
        this._isEnableMap = false
        this.changeFormData()
      }
    }
  }







  // FORM GROUP

  createForm(data?) {
    this.safetyCriticalForm = new FormGroup({
      name: new FormControl((data && data.name) ? data.name : ''),
      serialNo: new FormControl((data && data.serialNo) ? data.serialNo : ''),
      calibrated: new FormControl((data && data.calibrated) ? data.calibrated : ''),
      callibrationDue: new FormControl((data && data.callibrationDue) ? data.callibrationDue : ''),
      workingOrder: new FormControl((data && data.workingOrder) ? data.workingOrder : ''),
      calibration: new FormControl((data && data.calibration) ? data.calibration : '')
    })
    if (this._isControlDisable) {
      this.safetyCriticalForm.disable()
    }
  }







  // UTILITY

  onChangeEvent(value, formControl) {
    console.log("value of date", value);
    console.log('formControl', formControl);

    if (formControl == 'calibrated') {
      this.safetyCriticalForm.patchValue({ calibrated: value })
    }
    else if (formControl == 'callibrationDue') {
      this.safetyCriticalForm.patchValue({ callibrationDue: value })
    }
  }

  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }


  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })

      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }




  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  addNewForm() {
    this._assetService.closeDisplayFile(true)
    let obj = {
      _id: 'new',
      submissionDate: new Date(),
      userDocumentId: {}
    }
    let details = {}
    details['safety_critical_form'] = {}
    obj.userDocumentId['details'] = details
    this.safetyCriticalFormData.push(obj)
    this.selectedIndex = this.safetyCriticalFormData[this.safetyCriticalFormData.length - 1]._id
    this.selectedFormDetails = this.safetyCriticalFormData[this.safetyCriticalFormData.length - 1].userDocumentId
    this._isEnableMap = true
    this._isControlDisable = false
    // this.safetyCriticalFormData = []
    this.createForm({})
    // this.setCurrentLocation()
    // this.isEdit = false
    // this.isMapEdit = false
    this.files = []
  }


  changeFormTab(event, id, index) {
    console.log("event", event);
    console.log("id", id);
    console.log("inspectionFormData", this.safetyCriticalFormData);
    console.log("index", index);
    this.selectedIndex = this.safetyCriticalFormData[index]._id
    this.selectedFormDetails = this.safetyCriticalFormData[index].userDocumentId
    if (this.selectedIndex !== 'new') {
      this._isControlDisable = true
      this._isEnableMap = false
    } else {
      this._isControlDisable = false
      this._isEnableMap = true
    }
    this.changeFormData()

  }


  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address

  }


  changeFormData() {
    console.log("this.selectedFormDetails", this.selectedFormDetails);
    this.latitude = (this.selectedFormDetails.details.safetyCriticalForm && this.selectedFormDetails.details.safetyCriticalForm.location) ? this.selectedFormDetails.details.safetyCriticalForm.location.coords.lat : ''
    this.longitude = (this.selectedFormDetails.details.safetyCriticalForm && this.selectedFormDetails.details.safetyCriticalForm.location) ? this.selectedFormDetails.details.safetyCriticalForm.location.coords.lng : ''
    this.address = (this.selectedFormDetails.details.safetyCriticalForm && this.selectedFormDetails.details.safetyCriticalForm.location) ? this.selectedFormDetails.details.safetyCriticalForm.location.address : ''
    this.files = this.selectedFormDetails.files && this.selectedFormDetails.files.length ? this.selectedFormDetails.files : []
    this.safetyCriticalForm.value['location'] = {
      coords: { lat: this.latitude, lng: this.longitude },
      address: this.address
    }

    // this.isEdit = true
    // this.isMapEdit = true
    console.log("this file data check", this.files)
    this.createForm(this.selectedFormDetails.details.safetyCriticalForm)

  }


  // API CALL

  onSubmit() {
    this.loading = true
    console.log("condition is work...........", this.safetyCriticalForm.value)

    if (this.safetyCriticalForm.value.calibration == 'No') {
      this.safetyCriticalForm.patchValue({
        calibrated: '',
        callibrationDue: '',
      })
    }

    if (this.safetyCriticalForm.valid) {
      console.log('formgroup value', this.safetyCriticalForm.value);
      console.log('file value', this.files);


      if (this.isEdit) {
        let obj = {
          metaObj: {
            title: 'safety_critical_form',
          },
          documentId: this.selectedFormDetails.documentId,
          userId: this.userId,
          onModel: 'asset',
          documentMetaId: this.selectedFormDetails.documentMetaId,
          userDocumentId: this.selectedFormDetails._id,
          files: this.files,
          newFiles: this.newFiles,
          details: {}
        }

        this.safetyCriticalForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }

        let details = {
          safetyCriticalForm: this.safetyCriticalForm.value
        }
        obj['details'] = details
        this._userDocumentService.updateUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
          this.loading = false
          this.redirect();
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })
      } else {

        let obj = {
          metaObj: {
            title: 'safety_critical_form',
          },
          documentId: this.assetId,
          userId: this.userId,
          onModel: 'asset',
          files: this.files,
          details: {}
        }

        this.safetyCriticalForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }

        let details = {
          safetyCriticalForm: this.safetyCriticalForm.value
        }
        obj['details'] = details

        this._assetService.submitAssetForm(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.loading = false
          this.redirect();
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
          this.loading = false
        })

      }
    }
    else {
      this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      this.loading = false
    }
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    if (this.currentUser && (this.currentUser.userRole.includes('admin') || this.currentUser.userRole.includes('assetManager'))) {
      console.log("user is admin");
      this.router.navigate(['/asset/single-asset/' + this.assetData])
    }
    else {
      this.router.navigate(['/asset/asset-list/'])
    }
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }


}
